import Swiper from "swiper";
import {Navigation, Thumbs} from "swiper/modules";

const initDateSliderSections = () => {
    [...document.querySelectorAll('.date-slider-section')]
        .filter(item => item.dataset.init !== 'true')
        .forEach((item) => initDateSliderSection(item));
};

const initDateSliderSection = (section) => {
    section.dataset.init = true;
    const slider = section.querySelector('.date-slider');
    const slider_thumb = section.querySelector('.thumb-slider');
    const swiper_thumb = new Swiper(slider_thumb, {
        slidesPerView: 'auto',
        spaceBetween: 50,
        autoHeight: false,
        loop: true,
        centeredSlides: true,
        centeredSlidesBounds: true
    });
    const swiper = new Swiper(slider, {
        modules: [Navigation, Thumbs],
        slidesPerView: 1,
        spaceBetween: 0,
        autoHeight: false,
        loop: true,
        thumbs: {
            swiper: swiper_thumb,
        },
    });
    section.addEventListener('click', e => {
        const prevButton = e.target.closest('.swiper-button-prev');
        if(prevButton) {
            swiper.slidePrev();
            return;
        }
        const nextButton = e.target.closest('.swiper-button-next');
        if(nextButton) {
            swiper.slideNext();
            return;
        }
    })
};

export { initDateSliderSections };